var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactiveRegulation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6533 27H0.320007V1.33333H6.15334V0H17.82V1.33333H23.6533V27ZM1.65334 25.6667H22.32V2.66667H17.82V6.16667H6.15334V2.66667H1.65334V25.6667ZM7.48667 4.83333H16.4867V1.33333H7.48667V4.83333ZM10.82 20.4667L6.50334 16.15L8.13667 14.5167L10.82 17.2L17.0033 11.0167L18.6367 12.65L10.82 20.4667Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.82 20.4667L6.50336 16.15L8.13669 14.5167L10.82 17.2L17.0034 11.0167L18.6367 12.65L10.82 20.4667Z",
    fill: "#8E8E98"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveRegulation);
export default __webpack_public_path__ + "static/media/InactiveRegulation.063dc034707de8cd30c9fb4eddf003e5.svg";
export { ForwardRef as ReactComponent };